import {
  OrderLight,
  OrderPaymentStatus,
  OrderShipmentStatus,
  OrderStatusSummary,
  OrderSupplyStatus
} from 'src/typings';

export function getOrderSupplyStatusLabel(status?: OrderSupplyStatus) {
  switch (status) {
    case 'READY':
      return 'Готов';
    case 'WAITING_SUPPLY':
    default:
      return 'Ожидает поставку';
  }
}

type ReturnAwarePaymentInfo = Partial<
  Pick<
    OrderLight,
    'sum' | 'paid_total' | 'collectible_total' | 'has_returns'
  >
> &
  Partial<Pick<OrderStatusSummary, 'collectible_total' | 'paid_total' | 'has_returns'>>;

export function isClosedByReturn(order?: ReturnAwarePaymentInfo | null) {
  return (
    Number(order?.collectible_total || 0) <= 0.009 &&
    Number(order?.paid_total || 0) <= 0.009 &&
    Boolean(order?.has_returns)
  );
}

export function getOrderPaymentStatusLabel(
  status?: OrderPaymentStatus,
  order?: ReturnAwarePaymentInfo | null
) {
  if (isClosedByReturn(order)) {
    return 'Закрыт возвратом';
  }
  switch (status) {
    case 'PAID':
      return 'Оплачено';
    case 'PARTIALLY_PAID':
      return 'Частично оплачено';
    case 'UNPAID':
    default:
      return 'Не оплачено';
  }
}

export function getOrderShipmentStatusLabel(status?: OrderShipmentStatus) {
  switch (status) {
    case 'FULLY_SHIPPED':
      return 'Отгружено';
    case 'PARTIALLY_SHIPPED':
      return 'Частично отгружено';
    case 'UNSHIPPED':
    default:
      return 'Не отгружено';
  }
}

export function getOrderPaymentDue(
  order?: Pick<OrderLight, 'invoice_total' | 'paid_total' | 'sum' | 'collectible_total'>
) {
  const collectibleTotal =
    order?.collectible_total !== undefined && order?.collectible_total !== null
      ? Number(order.collectible_total)
      : Number(order?.sum || 0);
  return Math.max(collectibleTotal - Number(order?.paid_total || 0), 0);
}
